import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import LinkThumbnail
  from 'components/dashboard/links-content/common-link-item/LinkThumbnail';
import LinkName from 'components/dashboard/links-content/common-link-item/LinkName';
import LinkURL from 'components/dashboard/links-content/common-link-item/LinkURL';
import CommonLinkActions
  from 'components/dashboard/links-content/common-link-item/CommonLinkActions';
import LinkPublishedCheckbox
  from 'components/dashboard/links-content/common-link-item/LinkPublishedCheckbox';
import CommonLinkVideoOptions
  from 'components/dashboard/links-content/common-link-item/CommonLinkVideoOptions';
import CommonLinkTwitterOptions
  from 'components/dashboard/links-content/common-link-item/CommonLinkTwitterOptions';
import CommonLinkTiktokOptions
  from 'components/dashboard/links-content/common-link-item/CommonLinkTiktokOptions';
import CommonLinkPinterestOptions
  from 'components/dashboard/links-content/common-link-item/CommonLinkPinterestOptions';

import './CommonLinkItem.css';

function CommonLinkItem(props) {
  const {
    linkItem,
    patchLinkError,
    device,
  } = props;

  const [linkExpanded, setLinkExpanded] = useState(false);
  const [videoOptionsOpened, setVideoOptionsOpened] = useState(false);
  const [twitterOptionsOpened, setTwitterOptionsOpened] = useState(false);
  const [tiktokOptionsOpened, setTiktokOptionsOpened] = useState(false);
  const [pinterestOptionsOpened, setPinterestOptionsOpened] = useState(false);

  return (
    <div className="common-link-item__component">
      <div className="link-wrapper">

        {/* Link Header */}
        <div className={`link-header${linkExpanded ? ' bordered' : ''}`}>
          <div className="swap-icon-container">
            <CommonSwapIcon />
          </div>

          {!linkItem.is_header &&
            <div className="thumbnail">
              <LinkThumbnail
                linkId={linkItem.id}
                itemThumbnail={linkItem.thumbnail}
                itemThumbnailIcon={linkItem.thumbnail_icon}
              />
            </div>
          }

          <div className="link-info">
            <div className="link-name">
              <LinkName
                key={`common-link-name-key-${linkItem.id}`}
                linkName={linkItem.name}
                linkId={linkItem.id}
                isHeader={linkItem.is_header}
              />
            </div>

            {!linkItem.is_header &&
              <div className="link-url">
                <LinkURL
                  key={`common-link-url-key-${linkItem.id}`}
                  linkUrl={linkItem.url}
                  linkId={linkItem.id}
                  linkError={patchLinkError}
                />
              </div>
            }
          </div>

          <div className="link-actions">
            <CommonLinkActions
              linkItem={linkItem}
              linkExpanded={linkExpanded}
              setLinkExpanded={setLinkExpanded}
              videoOptionsOpened={videoOptionsOpened}
              setVideoOptionsOpened={setVideoOptionsOpened}
              twitterOptionsOpened={twitterOptionsOpened}
              setTwitterOptionsOpened={setTwitterOptionsOpened}
              tiktokOptionsOpened={tiktokOptionsOpened}
              setTiktokOptionsOpened={setTiktokOptionsOpened}
              pinterestOptionsOpened={pinterestOptionsOpened}
              setPinterestOptionsOpened={setPinterestOptionsOpened}
            />
          </div>

          <div className="is-published">
            <LinkPublishedCheckbox
              linkId={linkItem.id}
              isPublished={linkItem.is_published}
            />
          </div>

        </div>

        {/* Link Options */}
        {linkExpanded &&
          <div className="link-options-wrapper">
            <div className="mobile-link-actions">
              <CommonLinkActions
                mobile
                linkItem={linkItem}
                linkExpanded={linkExpanded}
                setLinkExpanded={setLinkExpanded}
                videoOptionsOpened={videoOptionsOpened}
                setVideoOptionsOpened={setVideoOptionsOpened}
                twitterOptionsOpened={twitterOptionsOpened}
                setTwitterOptionsOpened={setTwitterOptionsOpened}
                tiktokOptionsOpened={tiktokOptionsOpened}
                setTiktokOptionsOpened={setTiktokOptionsOpened}
                pinterestOptionsOpened={pinterestOptionsOpened}
                setPinterestOptionsOpened={setPinterestOptionsOpened}
              />
            </div>

            {videoOptionsOpened &&
              <div className="video-options">
                <CommonLinkVideoOptions
                  key={`common-link-video-option-${linkItem.id}`}
                  linkItem={linkItem}
                />
              </div>
            }

            {twitterOptionsOpened &&
              <div className="twitter-options">
                <CommonLinkTwitterOptions
                  key={`common-link-twitter-option-${linkItem.id}`}
                  linkItem={linkItem}
                />
              </div>
            }

            {tiktokOptionsOpened &&
              <div className="tiktok-options">
                <CommonLinkTiktokOptions
                  key={`common-link-tiktok-option-${linkItem.id}`}
                  linkItem={linkItem}
                />
              </div>
            }

            {pinterestOptionsOpened &&
              <div className="pinterest-options">
                <CommonLinkPinterestOptions
                  key={`common-link-pinterest-option-${linkItem.id}`}
                  linkItem={linkItem}
                />
              </div>
            }

          </div>
        }

        {/* Arrow Button */}
        {(!['desktop'].includes(device) || videoOptionsOpened || twitterOptionsOpened) &&
           <div
              className="arrow-button"
              onClick={() => setLinkExpanded(!linkExpanded)}
              role="button"
              tabIndex={-1}
            >
              <div className={`icon${linkExpanded ? ' up' : ' down'}`} />
            </div>
          }
      </div>
    </div>
  );
}

CommonLinkItem.propTypes = {
  linkItem: PropTypes.object.isRequired,
  patchLinkError: PropTypes.object,
  device: PropTypes.string.isRequired,
};

CommonLinkItem.defaultProps = {
  patchLinkError: null,
};

const mapStateToProps = state => (
  {
    patchLinkError: state.linksReducer.patchLinkError,
    device: state.commonReducer.device,
  }
);

export default connect(
  mapStateToProps,
  {},
)(CommonLinkItem);
